import React from "react";

// Local Imports
import "./style.css"

function Header() {

    return (
        <header>
            <h1 className="headerText">
                <span className="whiteText">
                    <span className="M">M</span>
                    <span className="A">A</span>
                    <span className="S">S</span>
                    <span className="T">T</span>
                    <span className="E">E</span>
                    <span className="R">R</span>
                </span>
                MIND
            </h1>
        </header>
    );
}

export default Header;